import React from 'react';
import HomeownerOnboardingComponent from '../../components/HomeOwnerDashboard/HomeownerOnboarding/HomeownerOnboardingComponent';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const HomeownerOnboarding = () => {
  return (
    <WithNavigation
      title="Dashboard"
      border
      top={<HomeownerOnboardingComponent />}
    />
  );
};

export default HomeownerOnboarding;